<script>
  import Password from "./Password.svelte";
  import Details from "./details3.svelte";
  import { onMount } from "svelte";

  const isLocalStorageAvailable = typeof localStorage !== "undefined";
  let enteredPassword = false;

  onMount(() => {
    enteredPassword = isLocalStorageAvailable
      ? localStorage.getItem("superSecure") || false
      : false;
  });

  function handleSubmit() {
    enteredPassword = true;
    if (isLocalStorageAvailable) {
      localStorage.setItem("superSecure", true);
    }
  }
</script>

<div class="sans-serif">
  {#if !enteredPassword}
    <Password on:submit={handleSubmit} />
  {:else if enteredPassword}
    <Details />
  {/if}
</div>

<style>
  @media (min-width: 640px) {
    div {
      max-width: none;
    }
  }
</style>
